(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["list-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function applyMobileTwoUpWithDots($el){
    if (!$el || !$el.length || !window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;

    var responsiveOpts = [
      // Phones & small tablets: 2 tiles, dots yes, arrows no
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false, dots: true, infinite: false } },
      { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false, dots: true, infinite: false } }
    ];

    if ($el.hasClass('slick-initialized')) {
      $el.slick('slickSetOption', 'responsive', responsiveOpts, true);
      $el.slick('setPosition');
    } else {
      if (window.innerWidth < 992) {
        $el.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,   // no arrows on mobile
          dots: true,      // dots on mobile
          infinite: false,
          rtl: document.documentElement.dir === 'rtl'
        });
      }
    }
  }

  function run() {
    if (!window.jQuery) return;
    var $el = jQuery('.js_col_breacrumb');
    applyMobileTwoUpWithDots($el);
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && e.target.querySelector('.js_col_breacrumb')) run();
  });

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(run, 150);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
